/**
 * Public Header Component
 * Clean, minimal navigation
 */

import { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { EdunaIcon } from '../common/EdunaLogo';
import '../../styles/eduna-marketing.scss';

export default function PublicHeader() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  if (pathname === '/login') return null;

  return (
    <nav className="eduna-navbar sticky-top">
      <div className="container">
        <div className="d-flex align-items-center justify-content-between w-100">
          {/* Logo */}
          <a
            className="eduna-navbar__brand"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
          >
            <span className="eduna-navbar__brand-icon">
              <EdunaIcon size={32} />
            </span>
            EDUNA
          </a>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler border-0 d-lg-none"
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle navigation"
          >
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          {/* Desktop Navigation */}
          <div className="d-none d-lg-flex align-items-center gap-1">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
              }
            >
              Home
            </NavLink>
            <NavLink
              to="/features"
              className={({ isActive }) =>
                `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
              }
            >
              Features
            </NavLink>
            <NavLink
              to="/pricing"
              className={({ isActive }) =>
                `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
              }
            >
              Pricing
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
              }
            >
              About
            </NavLink>
            <NavLink
              to="/faq"
              className={({ isActive }) =>
                `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
              }
            >
              FAQ
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
              }
            >
              Contact
            </NavLink>
          </div>

          {/* Desktop Actions */}
          <div className="d-none d-lg-flex align-items-center gap-2">
            <button
              className="btn eduna-btn-outline"
              onClick={() => navigate('/login')}
            >
              Login
            </button>
            <button
              className="btn btn-primary eduna-btn-primary"
              onClick={() => navigate('/register')}
            >
              Get Started
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="d-lg-none mt-3 pb-3">
            <div className="d-flex flex-column gap-1">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </NavLink>
              <NavLink
                to="/features"
                className={({ isActive }) =>
                  `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Features
              </NavLink>
              <NavLink
                to="/pricing"
                className={({ isActive }) =>
                  `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Pricing
              </NavLink>
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </NavLink>
              <NavLink
                to="/faq"
                className={({ isActive }) =>
                  `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                FAQ
              </NavLink>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  `eduna-navbar__link ${isActive ? 'eduna-navbar__link--active' : ''}`
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </NavLink>
            </div>
            <div className="d-flex flex-column gap-2 mt-3 pt-3" style={{ borderTop: '1px solid var(--eduna-gray-200)' }}>
              <button
                className="btn eduna-btn-outline w-100"
                onClick={() => {
                  navigate('/login');
                  setIsMenuOpen(false);
                }}
              >
                Login
              </button>
              <button
                className="btn btn-primary eduna-btn-primary w-100"
                onClick={() => {
                  navigate('/register');
                  setIsMenuOpen(false);
                }}
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
